/* unplugin-vue-components disabled */import __unplugin_components_0 from '/home/pedrazzi/projetos/advogados/v5/src/components/Breadcrumbs.vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-img",
        {
          staticClass: "px-4",
          attrs: {
            height: _vm.height,
            src: "src/images/parallax/horario.webp",
            gradient: "to top right, rgba(0,0,0,.45), rgba(0,0,0,.2)",
            flat: "",
            dark: "",
            tile: "",
          },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 fill-height text-center boas",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("h1", [_vm._v("Horário de Atendimento")]),
                _vm._v(" "),
                _c("p", [_vm._v("Confira nosso horário de atendimento")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(__unplugin_components_0, {
        staticClass: "rounded-0 my-3 mx-4",
        attrs: { items: _vm.menu },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mx-4" },
        [
          _c(
            "v-card",
            {
              staticClass: "mt-6 mb-8 mx-auto pa-0",
              attrs: { "max-width": "400", flat: "" },
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "pa-0",
                  attrs: {
                    text: "",
                    color: _vm.$vuetify.theme.isDark
                      ? "grey lighten-4"
                      : "grey darken-4",
                  },
                },
                [
                  _c("v-simple-table", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c(
                              "tbody",
                              _vm._l(_vm.list, function (item, idx) {
                                return _c(
                                  "tr",
                                  {
                                    key: idx,
                                    class: {
                                      active: item.status,
                                      transp: !item.status,
                                      "font-weight-black": item.status,
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "px-2 align-middle text-capitalize",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.status
                                      ? _c(
                                          "td",
                                          {
                                            staticClass:
                                              "px-1 align-middle text-center",
                                          },
                                          _vm._l(
                                            item.times,
                                            function (time, _idx) {
                                              return _c("span", { key: _idx }, [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(time.start) +
                                                    "-" +
                                                    _vm._s(time.end) +
                                                    "\n                    "
                                                ),
                                                item.times.length > 1 &&
                                                _idx < 1
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "mx-2" },
                                                      [
                                                        _vm._v(
                                                          "\n                      e\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-middle text-center",
                                          },
                                          [_vm._v("Fechado")]
                                        ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            {
              staticClass: "pa-0 mx-auto",
              attrs: { "max-width": "400", flat: "" },
            },
            [
              _vm.site.whatsapp
                ? _c(
                    "btn-whatsapp",
                    {
                      attrs: {
                        block: "",
                        large: "",
                        dark: "",
                        color: "success darken-1",
                      },
                    },
                    [_vm._v("Agendar consulta")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }